import React from "react";
import ReactDOM from "react-dom";

import App from "./Components/App";
import GlobalStyles from "./Styles/GlobalStyles";

ReactDOM.render(
  <>
    <GlobalStyles />
    <App />
  </>,
  document.getElementById("root")
);
